import React, { useState, ChangeEvent } from 'react';
import SignupTextField from './SignupTextField';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { signSetAction } from '../../../store/signup/actions';
import { useNavigate } from 'react-router';
import { AppState } from '../../../store';
import Autocomplete, {
    AutocompleteRenderInputParams,
} from '@material-ui/lab/Autocomplete';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { SimpleTextFieldComponentProps } from './SimpleTextFieldComponent';
import { pushEvent } from 'utils/clevertapUtils';

export const inputFieldPadding = 16;

export const useAutoCompleteStyle = makeStyles((theme) => ({
    inputRoot: {
        paddingRight: '0 !important',
        '& .MuiAutocomplete-input': {
            padding: `${inputFieldPadding}px !important`,
        },
    },
    option: {
        color: theme.palette.primary.main,
        paddingTop: 17,
        paddingBottom: 13,
        borderBottom: '1px solid rgba(0,0,0,.12)',
    },
    listbox: {
        padding: 0,
    },
}));

interface SimpleAutocompleteTextFieldComponentProps
    extends SimpleTextFieldComponentProps {
    options: string[];
    onChange?: (value: string) => void;
    okEvent?: string;
}

const SimpleAutocompleteTextFieldComponent: React.FC<SimpleAutocompleteTextFieldComponentProps> =
    ({
        nextLink,
        reduxKey,
        errorText,
        nullErrorText,
        isOptional,
        placeholderText,
        maxLength,
        type,
        validation,
        options,
        onChange,
        okEvent,
    }) => {
        const dispatch = useAppDispatch();
        const push = useNavigate();
        const classes = useAutoCompleteStyle();
        const { defaultValue } = useSelector((state: AppState) => ({
            defaultValue: state.Signup[reduxKey],
        }));
        const [value, setValue] = useState<string>(
            defaultValue?.toString() || '',
        );
        const onChangeInternal = (value: string) => {
            setValue(value);
            onChange?.(value);
        };
        const handleChange = (e: ChangeEvent<{}>, value: string | null) => {
            if (value && value.length > maxLength) return;
            return onChangeInternal(value || '');
        };
        const onSubmit = () => {
            if (okEvent) {
                pushEvent(okEvent);
            }
            if (!value && !isOptional) return;
            dispatch(
                signSetAction({
                    [reduxKey]: value,
                }),
            );
            push(nextLink);
        };

        return (
            <Autocomplete
                freeSolo
                classes={classes}
                fullWidth={true}
                clearOnEscape
                closeIcon={null}
                options={options}
                onChange={handleChange}
                inputValue={value}
                renderInput={(params: AutocompleteRenderInputParams) => (
                    <SignupTextField
                        {...params}
                        value={value}
                        isFocus={true}
                        isOptional={isOptional}
                        type={type}
                        errorText={errorText}
                        nullErrorText={nullErrorText}
                        placeholder={placeholderText}
                        onChange={onChangeInternal}
                        onSubmit={onSubmit}
                        validation={validation}
                        maxLength={maxLength}
                    />
                )}
            />
        );
    };

export default SimpleAutocompleteTextFieldComponent;
